import { useMediaQuery } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';

const useIsMobile = () => {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down('xs'));
};

export default useIsMobile;
